import { render, staticRenderFns } from "./informationsDetails.vue?vue&type=template&id=71e797a2&"
import script from "./informationsDetails.vue?vue&type=script&lang=js&"
export * from "./informationsDetails.vue?vue&type=script&lang=js&"
import style0 from "./informationsDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71e797a2')) {
      api.createRecord('71e797a2', component.options)
    } else {
      api.reload('71e797a2', component.options)
    }
    module.hot.accept("./informationsDetails.vue?vue&type=template&id=71e797a2&", function () {
      api.rerender('71e797a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/device/informations/informationsDetails.vue"
export default component.exports